import React from "react";
import vector from "../../assets/pickupAssigned.svg";
import { Link } from "react-router-dom";
import styles from "./PickupAssigned.module.css";
import { useDispatch, useSelector } from "react-redux";
import { placeOrder } from "../../redux/actions/orderActions";
import Pic from "../../assets/newAssignPic.jpeg";

const PickupAssigned = ({ history }) => {
  const dispatch = useDispatch();

  const { pickupInfo: pick } = useSelector((state) => state.savePickup);
  const { dropoffInfo: drop } = useSelector((state) => state.saveDropoff);
  const { courierInfo: cour } = useSelector((state) => state.saveCourier);
  const { paymentInfo: pay } = useSelector((state) => state.savePaymentInfo);
  const { loading, error } = useSelector((state) => state.placeOrder);

  console.log(pick && pick.address.coordinates);
  console.log(drop && drop.address.coordinates);
  const courierInfo = {
    typeOfCourier: cour && cour.type,
    details: cour && cour.details,
    IsFragile: cour && cour.isFragile,
    weight: cour && cour.weight,
    lwh: cour && cour.lwh,
  };
  const pickup = {
    personName: pick && pick.pickupName,
    personNumber: pick && pick.pickupNumber,
    landmark: pick && pick.Landmark,
    address: {
      address: pick && pick.pickupLocation,
      coordinates: {
        lat: pick && pick.address.coordinates.lat,
        long: pick && pick.address.coordinates.long,
      },
    },
    time: pick && pick.time,
    date: pick && pick.date,
  };
  const dropoff = {
    personName: drop && drop.dropoffName,
    personNumber: drop && drop.dropoffNumber,
    landmark: drop && drop.Landmark,
    address: {
      address: drop && drop.dropoffLocation,
      coordinates: {
        lat: drop && drop.address.coordinates.lat,
        long: drop && drop.address.coordinates.long,
      },
    },
    time: drop && drop.time,
    date: drop && drop.date,
  };
  const payment = pay && pay.paymentType;
  const payment_amount = cour && cour.payment;
  const typeOfOrder = cour && cour.type;

  const place = () => {
    dispatch(
      placeOrder(
        courierInfo,
        pickup,
        dropoff,
        payment,
        payment_amount,
        typeOfOrder,
        history
      )
    );
  };

  return (
    <div className={styles.container}>
      {/* {error && alert("Something went wrong !")} */}
      <div className={styles.box}></div>
      <header>
        <Link to="/payment-modes">
          <i className={styles.backIcon + " fas fa-chevron-left"}></i>
        </Link>
        <h1>Pickup Assigned</h1>
      </header>
      <main>
        <img src={Pic} alt="pickup assigned" />
        <div className={styles.textContainer}>
          <h3>Your Pickup has been arranged</h3>
          <p>Thank you for choosing us for delivering your valuable stuffs.</p>
        </div>
      </main>
      <button onClick={place}>
        {loading ? <span>Placing...</span> : <span>Place Order</span>}
      </button>
    </div>
  );
};

export default PickupAssigned;
